export const validator = ({ name, totalAmount, totalUsedDollars }) => {
  const validation = { name: null, totalAmount: null }
  const parsedAmount = parseFloat(totalAmount)

  if (totalAmount === null) {
    validation.totalAmount = "Amount can not be blank."
  } else if (isNaN(parsedAmount)) {
    validation.totalAmount = "Amount must be a number."
  } else if (totalAmount < 0) {
    validation.totalAmount = "Amount must be greater than 0."
  } else if (totalUsedDollars && totalAmount < totalUsedDollars) {
    validation.totalAmount = "Amount can not be less than Amount Used."
  }

  if (name === null || name.trim() === "") {
    validation.name = "Name can't be blank."
  }

  return validation
}
